var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bigStat"},[_c('b-row',[_c('b-col',{staticClass:"bigNumber",attrs:{"cols":"4","align-self":"streach"}},[_c('b',[_vm._v(_vm._s(_vm.slice.primary.BigNumber))])]),_c('b-col',{staticClass:"statText",attrs:{"align-self":"end"}},[_c('prismic-rich-text',{attrs:{"field":_vm.slice.primary.StatText}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }